// filepath: \wsl$\Ubuntu\home\hrko\webroot\fresh\resources\js\utils\helpers\handleDownload.js

/**
 * Download interest file (CV or Motivation Letter) via RTK Query lazy triggers.
 *
 * @param {'cv'|'motiv'} type
 * @param {{id:number}} row
 * @param {string} displayName
 * @param {Function} triggerDownloadCv lazy RTK trigger (id) => promise
 * @param {Function} triggerDownloadMotivationLetter lazy RTK trigger (id) => promise
 * @returns {Promise<void>}
 */
export async function handleDownload(
  type,
  row,
  displayName,
  triggerDownloadCv,
  triggerDownloadMotivationLetter,
) {
  if (!row?.id) return;
  try {
    const res =
      type === 'cv'
        ? await triggerDownloadCv(row.id).unwrap()
        : await triggerDownloadMotivationLetter(row.id).unwrap();

    const { blob, headers } = res || {};

    // Try to get filename from Content-Disposition; fallback to provided displayName
    let filename = displayName || 'download';
    const disposition =
      headers?.['content-disposition'] || headers?.get?.('content-disposition');
    if (disposition && typeof disposition === 'string') {
      const match = disposition.match(
        /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i,
      );
      const raw = match?.[1] || match?.[2];
      if (raw) {
        try {
          filename = decodeURIComponent(raw.replace(/\+/g, '%20'));
        } catch (_) {
          filename = raw;
        }
      }
    }

    const blobUrl = window.URL.createObjectURL(new Blob([blob]));
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (_) {
    // Error toasts are handled globally; swallow here.
  }
}
